<template>
  <div class="phone-container" :style="[container_Style]">
    <div class="phone_body">
      <div class="phone_item phone_header">
        <div class="item_cnt">
          <div class=""></div>
          <div class="no_select_mask" :class="{ 'select_mask': selectOne == '1' }"></div>
        </div>
      </div>
      <div class="phone_item phone_nav">
        <div class="item_cnt">
          <div class=""></div>
          <div class="no_select_mask" :class="{ 'select_mask': selectOne == '1' }"></div>
        </div>
      </div>
      <div class="phone_item phone_fixed">
        <div class="item_cnt">
          <div class=""></div>
          <div class="no_select_mask" :class="{ 'select_mask': selectOne == '2' }"></div>
        </div>
      </div>
      <div class="phone_item phone_tabber">
        <div class="item_cnt">
          <div class="tabberList">
            <div class="tabberList_item" v-for="(item, index) in uniTabberList" :key="index">
              <div class="tabimg" v-if="['home'].includes(item.key)">
                <el-image v-if="item.img1" class="img_class" :style="[image_Style]" :src="item.img1" :fit="fit"></el-image>
              </div>
              <div class="tabimg" v-else-if="['curt','user'].includes(item.key)">
                <el-image v-if="item.img0" :class="(item.key == 'curt'&&classType=='2')?'img_class-big':'img_class'" :style="[image_Style]" :src="item.img0" :fit="fit"></el-image>
              </div>
              <div class="tabimg" v-else>
                <el-image v-if="item.img0" class="img_class" :style="[image_Style]" :src="item.img0" :fit="fit"></el-image>
              </div>
              <div class="tabname" v-if="index == 0" :style="[tabnameStyle(true)]">{{ item.name }}</div>
              <div class="tabname" v-else-if="item.key == 'curt'&&classType=='2'" :style="[tabnameStyle(true)]"></div>
              <div class="tabname" v-else :style="[tabnameStyle(false)]">{{ item.name }}</div>
            </div>
          </div>
          <div class="no_select_mask" :class="{ 'select_mask': selectOne == '3' }"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import countdown from '@/components/countdown.vue'

export default {
  components: {
    countdown
  },
  props: {
    compData: {
      type: [Array,Object],
      default: () => []
    }
  },
  options: {
    styleIsolation: 'shared' // 解除样式隔离
  },
  data () {
    return {
      showDialog: false,
      curtab: {
        categoryList: []
      },
      curtabIndex: 0,
      queryInfo: {
        condition: {},
        currPage: 1,
        pageSize: 100
      },
      grouponWeappListDataList: [[], []],
      selectOne: '3',
      // unicOneGInfo: [],
    }
  },
  watch: {
    compData: {
      handler: function (newVal) {
        if (newVal) {
          this.$nextTick(() => {
            console.log('thdfghjk---1', newVal, '|-0')
            return
            this.curtab = newVal?.attr?.['a0']?.groupList?.[0]
            if (!this.curtab) return
            this.goodsList(this.curtab, 0)
            if (this.modetype == '2' && this.activityNum > 1) {
              this.goodsList(newVal?.attr?.['a0']?.groupList?.[1], 1)
            }
          })
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    // 数据
    uniTabberList () {
      return this.compData?.attr?.['a2']?.value
    },
    // 分类
    classType () {
      return this.compData?.attr?.['a0']?.value
    },
    // 仅选中时展示图标
    showselectImg () {
      return this.compData?.attr?.['a1']?.value
    },
    // 应用页面
    usingPage () {
      return this.compData?.attr?.['a3']?.value
    },
    // 导航图标色
    navColorType () {
      return this.compData?.attr?.['a4']?.value
    },
    //未选中颜色
    unselectColor () {
      return this.compData?.attr?.['a5']?.value
    },
    // 选中颜色
    selectColor () {
      return this.compData?.attr?.['a6']?.value
    },
    // unicOneGInfo(){
    //   return async activityCode=>{
    //     const _info = await this.getGroupInfo(activityCode)
    //     console.log('goghielnd---0',activityCode, _info)
    //     return _info
    //   }
    // },
    // 数据
    goodsList () {
      return async (curtab, index) => {
        console.log('dddf',curtab, index)
        return
        // const _index = this.groupList.findIndex(item=>item.groupId == this.curtab.groupId)
        const _SeckillListData = await this.getgoods(curtab, index)
        // this.curtabIndex = _index
        this.grouponWeappListData = _SeckillListData
        this.$set(this.grouponWeappListDataList, index, _SeckillListData)
        // this.grouponWeappListDataList[index] = _SeckillListData
        return _SeckillListData
      }
    },
    listClass () {
      return this.compData?.attr?.['a1']?.value
    },
    // 样式
    container_Style () {
      // return {
      //   [this.compData?.attr?.['a2']?.key]: this.compData?.attr?.['a2']?.value,
      //   [this.compData?.attr?.['a7']?.key]: this.compData?.attr?.['a7']?.value,
      //   [this.compData?.attr?.['a8']?.key]: `${this.compData?.attr?.['a8']?.value}px`,
      //   'background-color': this.goodsClass == '1' || this.goodsClass == '3' ? this.bgcolor : 'transparent',
      // }

      // let bgColor;
      console.log(this.goodsClass)

      switch (this.goodsClass) {
        case '1':
        case '3':
          // bgColor = this.bgcolor;

          return {
            [this.compData?.attr?.['a2']?.key]: this.compData?.attr?.['a2']?.value,
            [this.compData?.attr?.['a7']?.key]: this.compData?.attr?.['a7']?.value,
            [this.compData?.attr?.['a8']?.key]: `${this.compData?.attr?.['a8']?.value}px`,
            'background-color': this.bgcolor
          }
          // break;
        case '5':

          return {
            [this.compData?.attr?.['a2']?.key]: this.compData?.attr?.['a2']?.value,
            [this.compData?.attr?.['a7']?.key]: this.compData?.attr?.['a7']?.value,
            [this.compData?.attr?.['a8']?.key]: `${this.compData?.attr?.['a8']?.value}px`,
            'background-color': 'linear-gradient(to bottom, #feebec, #ffffff)'
          }

          // bgColor = "linear-gradient(to bottom, #feebec, #ffffff)";
          // break;
        default:

          return {
            [this.compData?.attr?.['a2']?.key]: this.compData?.attr?.['a2']?.value,
            [this.compData?.attr?.['a7']?.key]: this.compData?.attr?.['a7']?.value,
            [this.compData?.attr?.['a8']?.key]: `${this.compData?.attr?.['a8']?.value}px`,
            'background-color': 'transparent'
          }

          // bgColor = 'transparent';
      }
    },
    image_Style () {
      return {
      }
    },
    fit () {
      return 'contain'
    },
    tabnameStyle () {
      return selected => {
        switch (this.navColorType){
          case '1':
            return {
              'color': selected ? this.selectColor : this.unselectColor
            }
          case '2':
            return {
              'color': selected ? this.selectColor : this.unselectColor
            }
          default:
            return{}
        }
      }
    },
  },
  created () {
  },

  mounted () {
    this.$nextTick(() => {
      // console.log('-----2',this.unicOneGInfo(this.unicOne?.activityCode,666))
    })
  },

  methods: {
    initData () {
    },
    hilarity () {
    },
    handleFinish (item) {
    },
  }
}
</script>

<style lang="scss" scoped>
.phone-container {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  position: relative;
}
.phone_body{
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .7);
}
.phone_item{
  position: absolute;
  width: 100%;
  background: rgba(255, 255, 255, 1);
}
.item_cnt{
  position: relative;
  width: 100%;
  height: 100%;
}
.no_select_mask{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .6);
  &:hover{
    background: transparent;
    cursor: pointer;
  }
}
.select_mask{
  background: transparent;
}
.phone_header{
  top: 0;
  height: 95px;
  .item_cnt{
    background-image: url("../../../../assets/images/phoneHeader.png");
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
  }
}
.phone_nav{
  top: 95px;
  height: 100px;
}
.phone_fixed{
  right: 0;
  bottom: 60px;
  width: 64px;
  height: 58px;
}
.phone_tabber{
  bottom: 0;
  height: 50px;
  .tabberList{
    display: flex;
    height: 100%;
    .tabberList_item{
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      font-size: 10px;
      height: 100%;
      text-align: center;
      vertical-align: middle;
      flex: 1;
      .tabimg{
        width: 100%;
        height: 26px;
        margin: 5px auto;
      }
    }
  }
}
.img_class{
  display: block;
  width: 100%;
  height: 100%;
}
.img_class-big {
  width: 60px;
  height: 60px;
  transform: translateY(-30px);
}
</style>
